export const TransitionDuration = 250;
const TransitionConfig = `${TransitionDuration}ms ease-in-out`;
const ShadowSlight = '0 2px 10px rgba(45, 49, 50, 0.08)';
const ShadowHarsh = '0 2px 10px rgba(45, 49, 50, 0.2)';
const ShadowLayout = '0 2px 36px rgba(45, 49, 50, 0.1)';
const ShadowElevation = '0 2px 24px rgba(45, 49, 50, 0.2)';
const ShadowBig = '0 0 200px rgba(45, 49, 50, 0.5)';

export {
  TransitionConfig, ShadowSlight, ShadowLayout, ShadowHarsh, ShadowElevation, ShadowBig,
};
